import { render, staticRenderFns } from "./EconomyLeadOrdersTable.vue?vue&type=template&id=0c59c7d0&"
import script from "./EconomyLeadOrdersTable.vue?vue&type=script&lang=js&"
export * from "./EconomyLeadOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports